import { isManagedStorageUrl } from '@/utils/imageDisplayAccess';
import { isModelEthnicitySystemPresetAssetUrl } from '@/pages/ipe/workbench/constants/modelEthnicityPresetConfig';
import { isTryOnSystemPresetAssetUrl } from '@/pages/ipe/workbench/constants/modelTryOnPresetConfig';

/** 节点 16.3：静态 public assets 可走直链 */
export function isPublicSystemModelAssetUrl(url) {
  const raw = String(url || '').trim();
  if (!raw) return false;
  return isTryOnSystemPresetAssetUrl(raw)
    || isModelEthnicitySystemPresetAssetUrl(raw)
    || raw.startsWith('/assets/');
}

/** 节点 16.3：可用于 Network 图片请求的地址（禁止受管 /uploads/ 裸链） */
export function isNetworkSafeSystemModelImageSrc(url) {
  const raw = String(url || '').trim();
  if (!raw) return true;
  if (raw.startsWith('blob:') || raw.startsWith('data:')) return true;
  if (raw.includes('/api/storage/images/view')) return true;
  if (isPublicSystemModelAssetUrl(raw)) return true;
  if (isManagedStorageUrl(raw) && raw.includes('/uploads/')) {
    return false;
  }
  return true;
}

/** 节点 16.3：剥离受管裸链，仅保留签名 view 或 public assets */
export function blockBareManagedSystemModelImageSrc(url) {
  const raw = String(url || '').trim();
  if (!raw || isNetworkSafeSystemModelImageSrc(raw)) return raw;
  return '';
}
